module.exports = __webpack_public_path__ + "img/vt-02.a711337f.svg";